import {gql} from "@apollo/client";
import {getDomainGraphqlError, useMutation$} from "graphqlsupport";
import {useCallback} from "react";
import {showToast} from "common";
import {SubmitProviderMetricsInquiryInput} from "./SubmitInquiryModal";
import {format} from "date-fns-tz";
import {LOCAL_DATE_FORMAT} from "common";


const GRAPHQL_MUTATION = gql`
mutation submitProviderMetricsInquiry($input: ProviderMetricsInquirySubmitPayloadInput) {
    submitProviderMetricsInquiry(input: $input)
}`;

function transformInput(input: SubmitProviderMetricsInquiryInput) {
    const reportPeriodLocalDate = input.reportPeriod ?
        format(new Date(input.reportPeriod), LOCAL_DATE_FORMAT) : '';
    return {
        reportTypes: input.reportTypes,
        reportPeriodLocalDate: reportPeriodLocalDate,
        reportInquiringAbout: input.reportInquiringAbout,
        requestedSupport: input.requestedSupport,
    }
}


export function useSubmitProviderMetricInquiry$() {
    const {execute,} = useMutation$<{ input: object}, void>(GRAPHQL_MUTATION);
    const useSubmitProviderMetricInquiry = useCallback(async function (formValues: SubmitProviderMetricsInquiryInput | null) {
        if (formValues == null) {
            return;
        }


        try {
            await execute({
                variables: {
                    input: transformInput(formValues),
                }
            });

            showToast.success("Your Provider Data inquiry has been submitted. If you have additional information you'd like to add, please reach out to networkservices@catalight.org");
        } catch (errors: any) {
            if (getDomainGraphqlError(errors)) {
                showToast.error(getDomainGraphqlError(errors));
            } else {
                showToast.error(`Unable to submit Inquiry by ${errors.message || errors[0].message}`);
            }
        }
    }, [execute]);

    return {
        useSubmitProviderMetricInquiry
    }
}
